var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 18.0789C18 18.3441 17.8946 18.5985 17.7071 18.786C17.5196 18.9736 17.2652 19.0789 17 19.0789H1C0.734784 19.0789 0.48043 18.9736 0.292893 18.786C0.105357 18.5985 2.4071e-07 18.3441 2.4071e-07 18.0789V7.56891C-0.000105484 7.41652 0.0346172 7.26613 0.101516 7.12921C0.168415 6.99229 0.26572 6.87247 0.386 6.77891L8.386 0.555909C8.56154 0.419354 8.7776 0.345215 9 0.345215C9.2224 0.345215 9.43846 0.419354 9.614 0.555909L17.614 6.77891C17.7343 6.87247 17.8316 6.99229 17.8985 7.12921C17.9654 7.26613 18.0001 7.41652 18 7.56891V18.0789ZM16 17.0789V8.05691L9 2.61291L2 8.05691V17.0789H16ZM4 13.0789H14V15.0789H4V13.0789Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.e1ee795d8785713b513521245946b8c6.svg";
export { ForwardRef as ReactComponent };